import React from 'react';

function TabNavigation({ tabs, activeTab, onChange }) {
  return (
    <div className="border-b border-gray-200 mb-6 -mx-4 px-4 sm:mx-0 sm:px-0">
      <nav className="flex space-x-2 sm:space-x-8 overflow-x-auto scrollbar-hide pb-px snap-x snap-mandatory">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              type="button"
              onClick={() => onChange(tab.id)}
              className={`py-3 px-3 sm:px-1 border-b-2 font-medium text-sm transition-colors whitespace-nowrap flex-shrink-0 snap-start touch-manipulation ${
                isActive
                  ? 'border-tenq-gold text-tenq-gold'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              {tab.label}
            </button>
          );
        })}
      </nav>
    </div>
  );
}

export default TabNavigation;
